import Vue from "vue";
import Vuex from "vuex";
import injectables from "@/_shared/lib/meta/injectables";
import { isBuffer } from "lodash";
import axios from "axios";
import { getBy, findBy, findById } from "./getters";
import partials from "./partials/index";
Vue.use(Vuex);
import _ from "lodash";

export default new Vuex.Store({
  state: {
    ...partials.state,
    auth: false,
    user: undefined,
    entities: undefined,
    // landingPage: undefined,
    injected: false,
    plans: [],
    subscriptionNotes: null,
    faq: [],
    invitation: { entity_title: "test" },
  },

  getters: {
    ...partials.getters,
    getPlansBy: (state) => (key, value) => {
      if (!state.plans) return null;
      return getBy(state.plans, key, value);
    },

    findPlanBy: (state) => (key, value) => {
      if (!state.plans) return null;
      return findBy(state.plans, key, value);
    },

    findPlanById: (state) => (id) => {
      if (!state.plans) return null;
      return findById(state.plans, id);
    },
  },

  mutations: {
    ...partials.mutations,
    SET: (state, payload) => {
      if (Array.isArray(payload) && payload.length === 2) {
        state[payload[0]] = payload[1];
        return;
      }

      if (typeof payload === "object" && payload !== null) {
        for (let [key, value] of Object.entries(payload)) {
          state[key] = value;
        }
      }
    },
  },

  actions: {
    ...partials.actions,
    set({ commit }, payload) {
      return Promise.resolve(commit("SET", payload));
    },

    setAll({ state, commit }, payload) {
      const fields = [
        "auth",
        "user",
        "entities",
        "faq",
        "plans",
        "lang",
        "invitation",
        'subscriptionNotes'
      ];
      Object.keys(payload).forEach((field) => {
        if (fields.includes(field)) commit("SET", [field, payload[field]]);
      });
      commit("SET", {
        languageOptions: _.get(injectables, ["lang", "options"], []),
      });
      commit("SET", ["injected", true]);
    },

    async fetchAll({ dispatch, commit }) {
      try {
        const response = await axios.get("/web-api/app-data");
        dispatch("setAll", response.data);
        dispatch("set", {
          languageOptions: _.get(injectables, ["lang", "options"], []),
        });
        commit("SET", ["injected", true]);
      } catch (error) {
        console.log(error);
      }
    },

    inject({ dispatch, commit }) {
      if (!injectables) {
        dispatch("fetchAll");
        return;
      }
      dispatch("set", {
        languageOptions: _.get(injectables, ["lang", "options"], []),
      });
      dispatch("setAll", injectables);
      commit("SET", ["injected", true]);
      return;
    },
  },
  modules: {},
});
